// Translation: Verification > Landing > Form (Turkish)
export default Object.freeze({
	form: {
		actions: {
			verifyAccount: 'Hesabı doğrula'
		},
		fields: {
			code: {
				placeholder: 'Doğrulama kodunuzu girin'
			}
		},
		options: {
			resendCode: {
				label: {
					idle: 'Kodu tekrar gönder',
					success: 'Kod gönderildi!'
				}
			}
		},
		title: 'Hesap doğrulama'
	}
})
